import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { ModerationActionListItem } from '@/models/payment/moderation-action-list.model';

export class GetModerationActionListRequest extends ApiResourceMethod<ModerationActionListItem[]> {
  public perform(
    whitelabelSlug: string, playerId: string,
  ): Promise<ModerationActionListItem[]> {
    return this.performer.requestWithMapper(
      {
        url: `${whitelabelSlug}/player/${playerId}/paymentModerationAction`,
      },
      ({ data }: BaseResponse<ModerationActionListItem[]>): ModerationActionListItem[] => data,
    );
  }
}
